import {
  playerEventMarkersForMetricAtom,
  unwrappedPlayerEventMarkersForMetricAtom,
} from '@/atoms/queries/player/playerEventData';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { HeatMap } from '@/components/visualisations/HeatMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const PlayerHeatMap = ({ allowInteraction }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <HeatMap
      pitchEventsAtom={playerEventMarkersForMetricAtom}
      unwrappedPitchEventsAtom={unwrappedPlayerEventMarkersForMetricAtom}
      allowInteraction={allowInteraction}
    />
  </MetricKeyFallbackWrapper>
);
